import {defineQuery} from 'next-sanity';

import type {PageSchema} from './schema';

/**
 * Fetches all slugs of all pages
 * Returns an array of strings arrays that correspond to the urls
 * that need to be statically generated.
 * ['a'] => /a
 * ['a', 'b'] => /a/b
 * ['a', 'b', 'c'] => /a/b/c
 */
export const PAGE_SLUGS_QUERY = defineQuery(`
	*[_type == 'page' && defined(slug.current)].slug.current
`);

/**
 * Fetches the content of a page by its slug.
 * Returns all of the content associated with the page.
 */
export const PAGE_BY_SLUG_QUERY = defineQuery(`
	*[_type == "page" && slug.current == $pageSlug][0] {
		...,
		meta{
			...,
			image{
				asset->{
					url,
					metadata{
						dimensions{
							width,
							height
						}
					}
				}
			}
		}
	}
`);

export type PageBySlugQueryResult = PageSchema | null;
